import { useContext, useMemo } from 'react';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import useAlertStatus from '~/hooks/vdp/selectors/useAlertStatus';
import useIsInExclusivePreview from '~/hooks/vdp/selectors/useIsInExclusivePreview';
import useIsVehicleReservedByOther from '~/hooks/vdp/selectors/useIsVehicleReservedByOther';
import useIsWipVehicleReservedByUser from '~/hooks/vdp/selectors/useIsWipVehicleReservedByUser';
import ExclusivePreviewBanner from './ExclusivePreviewBanner';
import WIPReservable from './WIPReservable';
import WIPReservedByUserProgress from './WIPReservedByUserSteps';
import WIPSubscribed from './WIPSubscribed';

const useGetWipStatusBannerComponent = () => {
  const isReservedByOther = useIsVehicleReservedByOther();
  const isWipReservedByUser = useIsWipVehicleReservedByUser();
  const isInExclusivePreview = useIsInExclusivePreview();
  const { purchasePending, unavailable } = useAlertStatus();
  const { isSubscribedToNotifications } = useContext(UserVehicleContext);

  return useMemo(() => {
    switch (true) {
      case isInExclusivePreview:
        return <ExclusivePreviewBanner />;
      case isWipReservedByUser:
        return <WIPReservedByUserProgress />;
      case isReservedByOther && isSubscribedToNotifications:
        return null;
      case isSubscribedToNotifications:
        return <WIPSubscribed />;
      case purchasePending || unavailable:
        return null;
      default:
        return <WIPReservable />;
    }
  }, [
    isInExclusivePreview,
    isReservedByOther,
    isSubscribedToNotifications,
    isWipReservedByUser,
    purchasePending,
    unavailable
  ]);
};

export default useGetWipStatusBannerComponent;
